import { Link, useSearch } from '@tanstack/react-router';
import { twMerge } from 'tailwind-merge';
import { ASSET_ROUTE_URL } from '../../constants/routes';

type MarketCellProps = {
  className?: string;
  children?: React.ReactNode;
  subtitle?: React.ReactNode;
  icon?: React.ReactNode;
  ticker: string;
};

export const MarketCell: React.FC<MarketCellProps> = ({
  children,
  ticker,
  subtitle,
  icon,
  className,
}) => {
  const tradeRouteSearch = useSearch({
    from: ASSET_ROUTE_URL,
    shouldThrow: false,
  });

  return (
    <div className={twMerge('flex items-center gap-3 font-medium text-contentPrimary', className)}>
      {icon}
      <div className="flex flex-col">
        <Link
          to="/trade/$asset"
          params={{ asset: ticker }}
          search={tradeRouteSearch}
          className="text-nowrap font-medium text-contentPrimary"
        >
          {children}
        </Link>
        {subtitle && <div className="text-3xs text-contentSecondary">{subtitle}</div>}
      </div>
    </div>
  );
};
